import { getRequest } from '@/core';
import { customers } from '@/requests';
export default async function getCustomersRequest(filter) {
	try {
		let url = customers.getPath();
		return await getRequest(url, filter);
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}
